import { render, staticRenderFns } from "./OutOfBoundariesNotification.vue?vue&type=template&id=6219c6ac"
import script from "./OutOfBoundariesNotification.vue?vue&type=script&lang=ts"
export * from "./OutOfBoundariesNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports